import { useTranslation } from 'react-i18next';

/**
 * SetupNotice — shown when .env is missing or incomplete.
 *
 * Critical UX: a developer or Begüm running `pnpm dev` for the first time
 * without a configured .env should get a clear, localized message instead
 * of a Supabase auth error.
 */
export function SetupNotice() {
  const { t } = useTranslation();
  return (
    <main className="min-h-screen bg-bg-app text-text-primary font-sans flex items-center justify-center px-6 py-10">
      <div className="invite-frame max-w-md w-full bg-bg-elevated p-8 shadow-warm-md">
        <div className="text-center">
          <div className="text-5xl mb-4" aria-hidden="true">
            🛠️
          </div>
          <p className="eyebrow mb-1">{t('setup.eyebrow')}</p>
          <h1 className="font-serif italic text-3xl text-text-primary mb-4">
            {t('app.title')}
          </h1>
          <div className="ornament-divider mb-4" aria-hidden="true">
            <span>✦</span>
          </div>
          <p className="text-base text-text-secondary mb-4 leading-relaxed font-serif italic">
            {t('setup.missingEnv')}
          </p>
          <p className="text-sm text-text-secondary font-mono bg-bg-app rounded-lg p-3 border border-border-subtle">
            {t('setup.envFileMissing')}
          </p>
        </div>
      </div>
    </main>
  );
}
